/**
 * Progressive sample media under `public/media/`.
 * Primary fullscreen / Event View timeline uses the ~51s clip; shorter ~12s media
 * is available for secondary cameras and clip-export mocks.
 */
export const SAMPLE_PLAYBACK_MEDIA_URL = '/media/sample_video_51s.mp4';
export const SAMPLE_PLAYBACK_SHORT_MEDIA_URL = '/media/sample_video_12s.mp4';

/** Native duration of `sample_video_51s.mp4` (progressive remux mvhd). */
export const SAMPLE_PLAYBACK_DURATION_SECONDS = 51.16;

/** Native duration of `sample_video_12s.mp4` (progressive remux mvhd). */
export const SAMPLE_PLAYBACK_SHORT_DURATION_SECONDS = 12.412;

/**
 * Alarm-centered media window for the primary ~51s sample
 * (anchor ≈ 2026-03-27T11:00:00).
 */
export const SAMPLE_PLAYBACK_MEDIA_START = '2026-03-27T10:59:34.420';
export const SAMPLE_PLAYBACK_MEDIA_END = '2026-03-27T11:00:25.580';

/** Alarm-centered window for the short ~12s sample. */
export const SAMPLE_PLAYBACK_SHORT_MEDIA_START = '2026-03-27T10:59:53.794';
export const SAMPLE_PLAYBACK_SHORT_MEDIA_END = '2026-03-27T11:00:06.206';
